module.exports = __webpack_public_path__ + "static/media/insta.e94f5d28.svg";